import { render, staticRenderFns } from "./WildcardFormComponent.vue?vue&type=template&id=6120a89a&"
import script from "./WildcardFormComponent.vue?vue&type=script&lang=js&"
export * from "./WildcardFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports